//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
// import {requestByPost} from '@/util/request'
// import {API} from '@/util/api'
// import { Toast, PullRefresh,Empty,Overlay} from 'vant';
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'home',
 data(){
    return {
      show:false,//弹窗显示隐藏
      nowReleaseProdCase:null,//当前点击放大的案例对象
      nowIndex:0,//当前点击放大的案例下标
      showfix:false,//是否显示放大弹出层
      selType: 1,//查询数据类型 1查询案例  2查询企业
      oneProdTypeList: [{
          id:1,
          name:"河北省"
      },
      {
          id:2,
          name:"山西省"
      },
      {
          id:3,
          name:"辽宁省"
      },
      {
          id:4,
          name:"吉林省"
      },
       {
          id:5,
          name:"黑龙江省"
      }, {
          id:6,
          name:"江苏省"
      }, {
          id:7,
          name:"浙江省"
      }, {
          id:8,
          name:"安徽省"
      }, {
          id:9,
          name:"福建省"
      }, {
          id:10,
          name:"江西省"
      }, {
          id:11,
          name:"河北省"
      }, {
          id:12,
          name:"山东省"
      }, {
          id:13,
          name:"甘肃省"
      }, {
          id:14,
          name:"河南省"
      },
      {
          id:15,
          name:"湖北省"
      },
      {
          id:16,
          name:"湖南省"
      },
      {
          id:17,
          name:"广东省"
      },
      {
          id:18,
          name:"海南省"
      },
      {
          id:19,
          name:"四川省"
      },
      {
          id:20,
          name:"贵州省"
      },
      {
          id:21,
          name:"云南省"
      },
      {
          id:22,
          name:"陕西省"
      },
      {
          id:23,
          name:"青海省"
      },
      ],//省会分类
      TypeList:[
          {
          id:20,
          name:"内蒙古自治区"
      },
       {
          id:20,
          name:"广西壮族自治区"
      },
       {
          id:20,
          name:"西藏古自治区"
      },
       {
          id:20,
          name:"宁夏回族自治区"
      },
       {
          id:20,
          name:"新疆维吾尔自治区"
      },
      ],
      cityList:[
          {
          
          name:"北京市"
      },
      {
          
          name:"天津市"
      },
      {
          
          name:"上海市"
      },
      {
          
          name:"重庆市"
      },
      ],
      //广告
      List:[
          {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"150****2122",
              quotation:"未报价",
              botton:"立即报价"
          },
            {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
           {
              Img:require("../../assets/images/tx.png"),
              title:"AA广告制作星星广告-张总广告自...",
              time:"1小时前",
              place:"吉林省长春市",
              endtime:"截止时间：1天后",
              lead:"交货周期：3周",
              roll:"展会宣传易拉宝.PSD",
              phone:"未留电话",
              quotation:"未报价",
              botton:"立即报价"
          },
      ],
      twoProdTypeList: null,//产品行业分类

      searchStr: this.$route.query.searchStr,//输入框  搜索条件
      searchStrCompany: this.$route.query.searchStrCompany,
      pageSizeSel: 9,//分页条数


    }
  },
 components:{
    Header,
    Footer
 },

  methods:{
    Gopop(){
        this.show = !this.show
    }
    
  },
  mounted(){
    document.title = "找业务"
        $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":0})
      }
    })
  },
  created(){
 
    
  },
  updated(){
    // //每个16:9的图片加载完重新算高度
    // $$(".autoHeight").each(function(){
    //   let widthNum = $$(this).width();
    //   $$(this).height(widthNum*9/16);
    // });
    // //每个16:7.52的图片(企业封面)加载完重新算高度
    // $$(".autoCompanyImgHeight").each(function(){
    //   let widthNum = $$(this).width();
    //   $$(this).height(widthNum*7.52/16);
    // });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/business.vue